import type { DashboardMessageId } from "./dashboard.fr";

/** Tableau de bord in Italian. Same keys and {placeholders} as dashboard.fr.ts. */
export const dashboardIt: Record<DashboardMessageId, string> = {
  "dashboard.greeting": "Buongiorno, {name}",
  "dashboard.subtitle": "{date} · Conakry",
  "dashboard.generatedAt": "Dati letti alle {time} (fino a un minuto di ritardo).",
  "dashboard.refresh": "Aggiorna",
  "dashboard.refreshing": "Aggiornamento…",
  "dashboard.loading": "Caricamento della dashboard…",
  "dashboard.loadFailed": "Impossibile caricare la dashboard.",
  "dashboard.alertsAria": "Da gestire adesso",
  "dashboard.alert.open": "Apri →",
  "dashboard.alert.critical_report_open.tag": "Critico",
  "dashboard.alert.critical_report_open.text": "{count} segnalazione/i critica/che aperta/e.",
  "dashboard.alert.critical_report_open.review":
    "{count} persona/e sospesa/e fino a una decisione del team; prima revisione da fare entro il {date}.",
  "dashboard.alert.suspension_review_overdue.tag": "Revisione in ritardo",
  "dashboard.alert.suspension_review_overdue.text":
    "{count} sospensione/i hanno superato il termine di revisione (la più vecchia: {date}). Le persone restano sospese fino alla tua decisione.",
  "dashboard.alert.cases_past_deadline.tag": "Ritardo",
  "dashboard.alert.cases_past_deadline.text":
    "{count} pratica/che hanno superato il termine di prima risposta ({hours} h).",
  "dashboard.alert.thin_coverage.tag": "Offerta",
  "dashboard.alert.thin_coverage.text":
    "{trade} a {city}: {requests} richieste oggi per {pros} pro disponibile/i. È qui che bisogna reclutare.",
  "dashboard.alert.failed_payments.tag": "Pagamenti",
  "dashboard.alert.failed_payments.text": "{count} pagamento/i Orange Money non riuscito/i oggi.",

  "dashboard.card.demand": "Richieste del giorno",
  "dashboard.card.demand.answered": "Con risposta entro {hours} h",
  "dashboard.card.demand.unanswered": "Senza risposta",
  "dashboard.card.demand.expired": "Scadute",
  "dashboard.card.introductions": "Contatti avviati",
  "dashboard.card.introductions.quotes": "Preventivi inviati",
  "dashboard.card.introductions.median": "Tempo mediano di prima risposta",
  "dashboard.card.introductions.cancelled": "Annullate prima del contatto",
  "dashboard.card.pros": "Pro verificati",
  "dashboard.card.pros.unit": "attivi",
  "dashboard.card.pros.new": "Nuovi negli ultimi 7 giorni",
  "dashboard.card.pros.waiting": "In attesa di verifica",
  "dashboard.card.pros.suspended": "Sospesi",
  "dashboard.card.money": "Commissioni incassate",
  "dashboard.card.money.failed": "Pagamenti Orange Money non riusciti",
  "dashboard.card.money.approvals": "Richieste di approvazione in attesa",
  "dashboard.card.money.subscriptions": "Abbonamenti mensili attivi",

  "dashboard.coverage": "Copertura per mestiere e comune",
  "dashboard.coverage.empty": "Nessuna richiesta oggi.",
  "dashboard.coverageFoot":
    "In rosso: meno della metà delle richieste con risposta in tempo. È qui che bisogna reclutare.",
  "dashboard.col.trade": "Mestiere",
  "dashboard.col.commune": "Comune",
  "dashboard.col.requests": "Richieste",
  "dashboard.col.pros": "Pro disp.",
  "dashboard.col.answered": "Con risposta < {hours} h",

  "dashboard.queues": "Code di lavoro",
  "dashboard.noQueues": "Nessuna coda per i tuoi ruoli.",
  "dashboard.queue.late_cases": "Pratiche in ritardo",
  "dashboard.queue.open_cases": "Pratiche aperte",
  "dashboard.queue.open_cases.meta": "{count} non assegnata/e",
  "dashboard.queue.identity_verifications": "Verifiche d'identità",
  "dashboard.queue.identity_verifications.meta": "la più vecchia attende da {age}",
  "dashboard.queue.safety_reports": "Segnalazioni aperte",
  "dashboard.queue.severity.critical": "{count} critica/che",
  "dashboard.queue.severity.high": "{count} alta/e",
  "dashboard.queue.severity.medium": "{count} media/e",
  "dashboard.queue.severity.low": "{count} bassa/e",
  "dashboard.queue.overdue_suspension_reviews": "Revisioni di sospensione in ritardo",
  "dashboard.queue.overdue_suspension_reviews.meta": "ancora sospesi fino a una decisione",
  "dashboard.queue.payment_approvals": "Richieste di approvazione",
};
